import React from "react";
import {
    useSortable,
} from "@dnd-kit/sortable";

import {
    CSS
} from "@dnd-kit/utilities";

import {
    Box,
    IconButton
} from "@mui/material";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import ExamListItem from "./ExamListItem";
import { ExamByCodeResponse } from "../../../api/interfaces/preboard/Exam";

interface ExamCodeListItemProps {
    exam: ExamByCodeResponse;
    onEdit?: (exam: ExamByCodeResponse) => void;
    onDelete?: (exam: ExamByCodeResponse) => void;
    isSorting?: boolean;
}

const SortableExamItem: React.FC<ExamCodeListItemProps> = ({
    exam,
    onEdit,
    onDelete,
    isSorting = false
}) => {

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id: exam._id
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            sx={{
                opacity: isDragging ? 0.5 : 1
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <IconButton
                    {...attributes}
                    {...listeners}
                    size="small"
                    sx={{
                        mr: 1,
                        cursor: "grab"
                    }}
                >
                    <DragIndicatorIcon />
                </IconButton>

                <Box sx={{ flex: 1 }}>
                    <ExamListItem
                        exam={exam}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        isSorting={isSorting}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default SortableExamItem;